import React from "react";

// Mui Styles
// import { styled } from "@mui/material/styles";
import { StyledPaper } from "@/styles/mui/globalStyles";
import Grid from "@mui/material/Grid2";
import { createTheme, ThemeProvider } from "@mui/material/styles";

// CSS
import "@/styles/page/systemSettingProductPage.css";

// Navigate
import { useLocation, useNavigate } from "react-router-dom";
// Components
import DataTable from "@/components/dataTable";
import { SearchingBar } from "@/components/DataTable/searchingBar";
import Layout from "@/components/layout";
import Title from "@/components/title";
import { deliveryOrderManageTableColumn } from "@/config/tableColumnConfig";
import {
  ButtonSendTheme,
  SearchBarTheme,
  TableListTheme,
} from "@/styles/mui/tableListTheme";
// Moment
import { useSelector } from "react-redux";

import DateSelection from "@/components/dateSelection";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import LoadingButton from "@mui/lab/LoadingButton";
import moment from "moment";
import "moment/locale/zh-hk";

// Fetch
import { getDeliveryOrderList } from "@/fetch/fetchStock";

const DeliveryOrderPage = (props) => {
  const { open, setOpen } = props;

  // Navigate
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  // States
  const [dataTableLoading, setDataTableLoading] = React.useState(false);
  const [deliveryOrder, setDeliveryOrder] = React.useState([]);
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [edit, setEdit] = React.useState({ isDisable: true, editCount: 0 });
  const [searchStaffCode, setSearchStaffCode] = React.useState("");
  const [isLoading, setLoading] = React.useState(false);
  const defaultStartDate = moment().startOf("month");
  const defaultEndDate = moment().endOf("month");
  const startDate = useSelector(
    (state) =>
      state.system.selectedDate[pathname]?.startDate ?? defaultStartDate
  );
  const endDate = useSelector(
    (state) => state.system.selectedDate[pathname]?.endDate ?? defaultEndDate
  );
  // Fetch
  const fetchAll = async () => {
    try {
      setDataTableLoading(true);
      await getDeliveryOrderList(startDate, endDate, searchStaffCode).then(
        (data) => {
          if (data && data.results) {
            setDeliveryOrder(data.data);
          } else {
            setDeliveryOrder([]);
          }
          setLoading(false);
        }
      );
    } catch (error) {
    } finally {
      setDataTableLoading(false);
    }
  };
  // Theme
  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 16,
          },
        },
      },
    },
  });
  // Browser Back
  const handleBeforeUnload = (e) => {
    e.preventDefault();
    const message =
      "Are you sure you want to leave? All provided data will be lost.";
    e.returnValue = message;
    return message;
  };
  const onCellClick = (data) => {
    navigate(
      `/deliveryOrder/${data.row.stockonhand_refill_id}/${data.row.si_number}`
    );
  };
  React.useEffect(() => {
    fetchAll();

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      selectedIndex={20}
      header="deliveryOrderPage"
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      open={open}
      setOpen={setOpen}
    >
      <Title title="運送單" history={() => navigate(-1)} />
      <StyledPaper page={"yes"} alignItems="left">
        <ThemeProvider theme={theme}>
          <Grid container spacing={2}>
            <DateSelection
              defaultStartDate={defaultStartDate}
              defaultEndDate={defaultEndDate}
              md={4}
              lg={4}
              xs={12}
            ></DateSelection>
            <Grid
              size={{
                xs: 12,
                md: 2,
                lg: 2,
              }}
            >
              <ThemeProvider theme={SearchBarTheme}>
                <SearchingBar
                  value={searchStaffCode}
                  startAdornment={false}
                  clearSearch={() => setSearchStaffCode("")}
                  onChange={(event) => setSearchStaffCode(event.target.value)}
                  placeholder="員工編號"
                />
              </ThemeProvider>
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 2,
                lg: 2,
              }}
            >
              <ThemeProvider theme={ButtonSendTheme}>
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <LoadingButton
                    size="small"
                    onClick={() => {
                      setLoading(true);
                      fetchAll();
                    }}
                    endIcon={<SearchOutlinedIcon fontSize="small" />}
                    loading={isLoading}
                    loadingPosition="end"
                    variant="contained"
                  >
                    搜尋
                  </LoadingButton>
                </div>
              </ThemeProvider>
            </Grid>
          </Grid>
        </ThemeProvider>
      </StyledPaper>
      <StyledPaper page={"yes"}>
        <ThemeProvider theme={TableListTheme}>
          <DataTable
            loading={dataTableLoading}
            isCellEditable={() => edit.isDisable !== true}
            rows={deliveryOrder}
            columns={deliveryOrderManageTableColumn}
            getRowId={(row) => `${row.stockonhand_refill_id}-${row.si_number}`}
            pageSize={100}
            onCellClick={(data) => onCellClick(data)}
            initialState={{
              sorting: {
                sortModel: [{ field: "brand_types_name", sort: "asc" }],
              },
            }}
          />
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default DeliveryOrderPage;
